$(document).ready(function(){
    if(undefined !== window.OctaviaTheme) {
        window.OctaviaTheme.loadMoreProducts(oct_load_more_params);
    }

    /*
    this.LoadMore = new LoadMore();

    let canBeLoaded = true; // this param allows to initiate the AJAX call only if necessary
    const bottomOffset = 1500; // the distance (in px) from the page bottom when you want to load more posts

    if(this.scrollListener) window.removeEventListener(this.scrollListener);

    if(this.scrollEvent){ console.log("Found event"); }

    this.scrollEvent = (params) => {
        console.log("Scrolling");

        var data = {
            'action': 'oct_load_more',
            'query': params.posts,
            'page' : params.current_page
        };
        if($(document).scrollTop() > ($(document).height() - bottomOffset) && canBeLoaded){
            if(!canBeLoaded) return;

            $.ajax({
                url : params.ajaxurl,
                data: data,
                type: 'POST',
                beforeSend: (xhr) => {
                    canBeLoaded = false;
                    console.log("Getting more products...", this.LoadMore);
                    this.LoadMore.show();
                },
                success: (data) => {
                    this.LoadMore.hide();
                    if(data) {
                        $('.products').find('.product:last-of-type').after(data);
                        params.current_page++;
                        canBeLoaded = true;
                        //this.loadMoreProducts();
                    }
                },
                /*
                error: (data) => {
                    this.LoadMore.hide();
                    canBeLoaded = true;
                }
                *
            });
        }else{
            //loadMore.hide();
        }
    };

    this.scrollEventWithParams = this.scrollEvent(oct_load_more_params);

    this.scrollListener = window.addEventListener('scroll', this.scrollEventWithParams);

    console.log("Listening");
    */
});
